export const SET_LOADING = "SET_LOADING";

const setLoading = (entity, isLoading) => (dispatch) =>
  dispatch({
    type: SET_LOADING,
    payload: { entity, isLoading },
  });

export default setLoading;
